import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { config } from "./Configuration";
import { paymentService } from "../abstraction/IPaymentService";


interface ITransactionSignData {
    id: string;                          
    time: string;                       
    prevTransactionId?: string;          
    prevTransactionSignature?: string; 
    fromWalletId: string;
    toWalletId: string;
    orderId?: string;                   
    amount: number;                     
}

export function withSignManager<T>(action: (connectionId: string) => Promise<T>) {


    return new Promise<T>(async (res, rej) => {

        const connection = new HubConnectionBuilder()
            .withUrl(config.current.notificationUrl)
            .configureLogging(LogLevel.Information)
            .build();

        connection.on("signTransaction", async (data: ITransactionSignData, json: string) => {

            console.log(`Received: ${data}`); 

            try {

                console.log("JSON", json);

                const signature = paymentService.signPayloadPos(json);
                
                const finger = paymentService.getFingerprint("pos");

                await connection.invoke("TransactionSignature", data.id, signature, finger);
            }

            catch (ex) {

                await connection.invoke("TransactionSignature", data.id, null, null);

                rej(ex);
            }            
        });

        try {

            await connection.start();

            const result = await action(connection.connectionId);

            res(result);
        }
        catch (ex) {
            console.error("Error connecting:", ex);
            rej(ex);
        }
        finally {

            if (connection.state === "Connected")
                await connection.stop();
        }
    });

}